"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-portal";
//#region src/components/atoms/Portal/Portal.tsx
var r = e((e, r) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "portal",
	...e,
	ref: r
}));
r.displayName = "Portal";
//#endregion
export { r as Portal };
